import { DetailPanelStyle } from './DetailPanel.style'
import { HeaderStyle } from './Header.style'
import { ListPanelStyle } from './ListPanel.style'
import { ToggleListButtonStyle } from './ToggleListButton.style'

export const layoutComponentStyles = {
  components: {
    DetailPanelStyle,
    HeaderStyle,
    ListPanelStyle,
    ToggleListButtonStyle,
  },
}
